import { PlanoModel } from "../model/api/gestao/plano/plano-model";
import { EnumPlanoOpcoes } from "../model/enums/enum-plano-opcoes";

export const getPlanoLimite = (plano: PlanoModel | undefined, opcao: EnumPlanoOpcoes): number => {
    if (!plano)
        return 0;

    var finded = plano.opcoes.find(x => x.codigo === opcao);
    if (!finded)
        return 0;
    return parseInt(finded.valor);
}

export const isPlanoControleProducao = (plano: PlanoModel | undefined) => {
    const limite = getPlanoLimite(plano, EnumPlanoOpcoes.ControleProducao);
    return limite === 1;
};

export const isPlanoOperacaoDelivery = (plano: PlanoModel | undefined) => {
    const limite = getPlanoLimite(plano, EnumPlanoOpcoes.OperacaoDelivery);
    return limite === 1;
};

export const isPlanoDeliveryProprio = (plano: PlanoModel | undefined) => {
    const limite = getPlanoLimite(plano, EnumPlanoOpcoes.DeliveryProprio);
    return limite === 1;
};

export const isPlanoDelivery = (plano: PlanoModel | undefined) => {
    return isPlanoOperacaoDelivery(plano) || isPlanoDeliveryProprio(plano);
};